module.exports = __webpack_public_path__ + "static/media/PersonQuestionMark.b23e3acd.jpg";